import '../CSS/private/HomeTemplate.css';


/**
 * @param {*} props - backgroundImage = image to be used as the background for the site
 *                  - tagLine         = the large H1 text to be displayed over the background
 *                  - subTagLine      = the subtitle for the large H1 text
 *                  - AppBar          = instance of an AppBarTemplate for this specific app
 */
function HomeTemplate(props) {

  return (
    <div>

      <div className='slp-hometemplate-background' style={{backgroundImage: 'url("' + props.backgroundImage + '")'}}>
        {props.appBar}

        <div className='slp-hometemplate-tagline-container'>
          <h1 className='slp-hometemplate-tagline'>{props.tagLine}</h1>
          <h2 className='slp-hometemplate-subtagline'>{props.subTagLine}</h2>
        </div>
      </div>

    </div>
  )

}

export default HomeTemplate;